import React from 'react'
// import FullDetails from './FullCarBookingForm'
import SelectedFullCabDetails from './SelectedFullCabDetails'

const IndexFullcab = () => {
  return (
    <div style={{ fontFamily: 'Lato, sans-serif' }}>
      {/* <FullDetails/> */}
      <SelectedFullCabDetails/>
    </div>
  )
}

export default IndexFullcab
